import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCustomerAddress } from "../hooks";

type ICustomerAddressParams = {
  id: string;
};

export const CustomerAddress: React.FC = () => {
  const { id } = useParams<ICustomerAddressParams>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, loading } = useCustomerAddress(+id!);

  if (loading) return <Loading />;

  const address = data?.customerAddress?.result;

  return (
    <>
      <Header
        title="Adresse"
        subtitle={address?.label}
        buttons={[
          {
            actionText: "Modifier",
            bgColor: "indigo",
            textColor: "white",
            link: `/customer-address/${id}/update`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="section">
          <div className="element">
            <div className="card">
              <CardHeader title="Informations générales" />
              <div className="flex">
                <div className="w-1/2 mr-1">
                  <div className="w-full mt-3">
                    <p className="label">Type</p>
                    <input className="input w-full" value={address?.type} disabled />
                  </div>
                </div>
                <div className="w-1/2 ml-1">
                  <div className="w-full mt-3">
                    <p className="label">Libellé</p>
                    <input className="input w-full" value={address?.label} disabled />
                  </div>
                </div>
              </div>
              <div className="w-full mt-3">
                <p className="label">Rue</p>
                <input className="input w-full" value={address?.street} disabled />
              </div>
              <div className="flex">
                <div className="w-1/2 mr-1">
                  <div className="w-full mt-3">
                    <p className="label">Ville</p>
                    <input className="input w-full" value={address?.city} disabled />
                  </div>
                </div>
                <div className="w-1/2 ml-1">
                  <div className="w-full mt-3">
                    <p className="label">Active</p>
                    <input
                      className="input w-full"
                      value={address?.active ? "Oui" : "Non"}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="w-full mt-3">
                <p className="label">Client</p>
                <input
                  className="input w-full"
                  value={address?.customer?.name ?? ""}
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
